import { HelpService } from 'mbs-ui-shared@help/help.service';
import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';

export interface WizardHelpLinkHook {
  planType?: PlanTypes;
  overrideNeedShowHelpLink?(): boolean;
  getRAWHelpLinks?: () => Record<string, string>;
}

export class WizardHelpLink<T extends string> {
  public readonly helpLinkTypes = [PlanTypes.ConsistencyCheck, PlanTypes.DataBasePlan];
  public links: Record<T, string> = {} as Record<T, string>;
  public get needShowHelpLink(): boolean {
    if (typeof this.hooks.overrideNeedShowHelpLink === 'function') {
      return this.hooks.overrideNeedShowHelpLink();
    }

    return this.helpLinkTypes.includes(this.hooks.planType) && this.canShowHelpLink;
  }

  public get canShowHelpLink(): boolean {
    return this.helpService.hasRights();
  }

  constructor(
    private helpService: HelpService,
    private readonly hooks: WizardHelpLinkHook
  ) {}

  initHelpDocumentationLinks(): void {
    if (!this.canShowHelpLink) {
      return;
    }

    this.links = this.hooks.getRAWHelpLinks?.() || this.links;

    Object.keys(this.links).forEach((key) => {
      this.links[key] = this.helpService.getHelpLink(`/${this.links[key]}`);
    });
  }
}
